<template>
    <article v-on:click="openproduct" class="col-12 col-sm-6 col-md-4 col-lg-4 product effect-CatalogMoveIn"
             v-bind:class="{'exists-in-cart' : inCart, 'product-has-detail-page' : doOpenInOverlay, 'buyButtonDisabled' : product.buyButtonDisabled, 'orderItemClick' : orderItemClick}">
        <div class="col-12">
            <div class="row product-header">
                <div class="col-12">
                    <h6>{{product.name}}</h6>
                </div>
            </div>
            <div class="row product-content">
                <span v-if="inCart" class="icon-added-to-cart-round">
                    <i class="icon icon-check"><span>{{quantityInCart}}</span></i>
                </span>
                <div class="col-12">
                    <div class="product-main-image found" v-if="product.content.photos != null && product.content.photos.length > 0" :style="{ 'background-image': 'url(' + product.content.photos[0] + ')' }"></div>
                    <div class="product-main-image missing" v-else></div>
                </div>
                <div class="col-12 product-descr-web" v-html="product.content.description_web">

                </div>
                <div class="col-12 allergeen-wrap">

                    <div class="product-allergeen-informatie allergies-clickable">
                        <p v-for="allergyId in product.content.allergenen" v-bind:key="allergyId" class="allergy-icon" :class="getAllergy('id'+allergyId).fontIcon"></p>
                    </div>

                    <div class="product-button">
                        <button v-if="doOpenInOverlay" class="btn btn-default btn-with-pricelabel btn-open-product-details">
                            <span class="cart-button-price-field">{{totalPrice | toCurrency}}</span>
                            <span class="icon-price-field-plus">+</span>
                        </button>
                        <button v-else class="btn btn-default addtocart btn-with-pricelabel" v-on:click.stop="addproduct">
                            <span class="cart-button-price-field">{{totalPrice | toCurrency}}</span>
                            <span class="icon-price-field-plus">+</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>

    import { services } from '../Services/Services'
    import orderItemMixin from './Mixins/orderItemMixin'
    //import orderItemExtra from './order-item-extra.vue'
    import shoppingCartService from '../Services/ShopingCartService';

    export default {

        _timer: null,

        name: 'order-item',
        props: { 'product': Object },

        components: {},

        data: function () {
            return {
                collapsed: true,									            // a value indicationg wheter the product is collapsed or not
                // quantity: 1,										            // the quantity
                totalPrice: services.getDefaultDishPrice(this.product, 1),		// the price of the product
                orderItemClick: window.pwa_settings.list.orderOnItemClick
            };
        },

        computed: {
            inCart: function () {
                return (shoppingCartService.shoppingCart.model.items.filter(a => a.productId == this.product.id).length > 0);
            },
            quantityInCart: function () {
                return this.inCart ? shoppingCartService.shoppingCart.model.items.filter(a => a.productId == this.product.id)[0].quantity : 0;
            },
            doOpenInOverlay: function () {
                return (this.product.content.openInOverlay);
            }
        },

        methods: {
            addproduct: function () {
                this.addToBasket();
            },
            openproduct: function () {
                var _this = this;

                if (!this.product.buyButtonDisabled) {

                    if (this.doOpenInOverlay) {
                        // start up the following steps:
                        // ** get the product from server
                        // ** set the product.loaded to true
                        // ** order-item-detail-overlay whatches the .loaded property and set the UI to an overlay through the global navstate helper object
                        services.loadProduct(this.product.id);

                    } else {
                        // general settings on the page.
                        if (window.pwa_settings.list.orderOnItemClick) {
                            this.addToBasket();
                        }
                        //if (this._timer != null) {
                        //  window.clearTimeout(this._timer);
                        //  this.addedAnimation = false;
                        //  window.setTimeout(function () { _this.addedAnimation = true; }, 10);
                        //} else {
                        //  this.addedAnimation = true;
                        //}
                        //this._timer = window.setTimeout(function () { _this.addedAnimation = false; _this._timer  = null }, 500);
                    }
                }
            }
        },

        mixins: [orderItemMixin]
    }
</script>



// WEBPACK FOOTER //
// Vue/Src/Components/order-item.vue